import { Collapse, Fade, ListItem } from '@material-ui/core'

import useStyles from './styles/RatePlansAddPoliciesModalRow.styles'

interface RatePlansAddPoliciesModalRowProps {
  name: string
  selectedTemplate: string
  onClick: () => void
  showItems: boolean
  id: string
}
const RatePlansAddPoliciesModalRow: React.FC<
  RatePlansAddPoliciesModalRowProps
> = ({ name, id, selectedTemplate, onClick, showItems }) => {
  const classes = useStyles()
  return (
    <Collapse in={showItems} key={id}>
      <ListItem
        button
        className={[
          classes.templateItem,
          selectedTemplate === id ? classes.activeTemplateItem : ''
        ].join(' ')}
        onClick={onClick}>
        <Fade in={selectedTemplate === id} timeout={250}>
          <span className={classes.activeCircle} />
        </Fade>
        {name}
      </ListItem>
    </Collapse>
  )
}
export default RatePlansAddPoliciesModalRow
